import { Injectable } from '@angular/core';
import { UserDataService } from './user-data.service';
import { shareReplay, switchMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { Observable } from 'rxjs/internal/Observable';
import { timer } from 'rxjs/internal/observable/timer';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { map } from 'rxjs/internal/operators/map';

const CACHE_SIZE = 1;
const REFRESH_INTERVAL = 60000; // one minute

@Injectable({ providedIn: 'root' })
export class UserService {
    private allUsersObserver: Observable<BaseUserWithRole[]>;
    private teammatesObserver: Observable<BaseUserWithRole[]>;
    private unsubscriber = new Subject<void>();

    constructor(private userDataService: UserDataService) {}

    getAll(keyWords = ''): Observable<BaseUserWithRole[]> {
        const timerForUpdate = timer(0, REFRESH_INTERVAL);

        if (!this.allUsersObserver) {
            this.allUsersObserver = timerForUpdate.pipe(
                switchMap(() => {
                    return this.userDataService.getAll(true, keyWords);
                }),
                takeUntil(this.unsubscriber),
                shareReplay(CACHE_SIZE),
            );
        }

        return this.allUsersObserver.pipe(
            map((value) => {
                return structuredClone(value);
            }),
        );
    }

    getTeammates(keyWords = ''): Observable<BaseUserWithRole[]> {
        if (!this.teammatesObserver) {
            this.teammatesObserver = this.userDataService
                .getAll(false, keyWords)
                .pipe(shareReplay(CACHE_SIZE), takeUntil(this.unsubscriber));
        }
        return this.teammatesObserver.pipe(
            map((value) => {
                return structuredClone(value);
            }),
        );
    }

    reloadData() {
        this.unsubscriber.next();
        this.allUsersObserver = null;
        this.teammatesObserver = null;
    }
}
